// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"3f59d478","186":"f501908c","225":"852e402d","272":"6b7212e8","372":"bb99adde","377":"8860dc4c","573":"5a815c18","738":"719e399b","841":"89521c56","856":"7995438a","909":"ec535289"}[chunkId] + ".chunk.js";
};